import { PropInfo, Section } from "./components/sections/TextSection";
import { ArrowConfig } from "./layout-template/arrowConfig";
import { ImageConfig } from "./layout-template/imageConfig";
import { LineConfig } from "./layout-template/lineConfig";
import { RectangleConfig } from "./layout-template/rectangleConfig";
import { RichTextConfig } from "./layout-template/richTextConfig";
import { ScreenMeasuringUnit, IScreenSize } from "./types";
export interface LayoutConfig {
    sections: Section[];
    height: number | null;
    width: number | null;
    propInfo: PropInfo[];
    rowCount: number;
    colCount: number;
    cellWidth: number;
    cellHeight: number;
    defaultScreenSize:IScreenSize|null;
    scale: [number,number]|null;   
}

export const pageLevelDefaultProps:PropInfo[] = [
  {
        name: "Page Audio",
        inputType: "audio",
        binding: "audio",
        value:"",
        label: "Audio"
  }
]

export const layoutConfig: LayoutConfig = {
    sections: [
        RichTextConfig, 
        RectangleConfig, 
        ImageConfig, 
        LineConfig, 
        ArrowConfig
    ],
    propInfo: [
      {
        name:"Page Audio",
        inputType: 'audio',
        binding: 'audio',
        value: '',
        label: 'Page Audio',
      },
    ],
    height: null,
    width: null,
    rowCount: 250,
    colCount: 300,
    cellWidth: 1,
    cellHeight: 1,
    defaultScreenSize:{label:"Desktop",width:30,height:25,unit:ScreenMeasuringUnit.cm},
    scale:[1,1]
};


